import React from 'react';
import PropTypes from 'prop-types';
import { SFEntityID, starfishMediaType } from 'utils/types';
import { fetchAuthenticatedJSON, apiErrorMessage } from 'utils/request';
import ConfirmationView from './ConfirmationView';
import moment from 'moment';
import 'moment-timezone';

export default class ConfirmationContainer extends React.Component {

  constructor() {
    super();
    this.state = {
      hasFetched: false,
      startDate: null,
      duration: null,
      locationName: null,
      instructions: null,
      reasonName: null,
      ownerName: null,
      ownerTitle: null,
      ownerRoles: null,
      recurring: null,
      courseName: null,
      recurrenceEndDate: null,
      recurrenceLabel: null,
      studentNote: null,
      scheduleBlockInstructions: null
    };
  }

  componentDidMount() {
    this.setState({hasFetched: false});

    const URL = `../api/starfish/appointments/appointments/${this.props.id}`;
    fetchAuthenticatedJSON(URL, {
      method: 'GET',
      headers: {
        'Accept': starfishMediaType('appointments')
      }
    })
    .then(({appointment}) => this.setState({
      startDate: moment(appointment.startDate).tz(this.props.studentTimeZone),
      duration: appointment.duration,
      locationName: appointment.location.name,
      instructions: appointment.location.instructions,
      reasonName: appointment.appointmentReason,
      ownerName: appointment.owner.name,
      ownerTitle: appointment.owner.title,
      ownerRoles: appointment.owner.roles,
      recurring: appointment.recurring,
      recurrenceLabel: appointment.scheduleBlock.recurrenceLabel,
      courseName: appointment.courseContext ? appointment.courseContext.name : null,
      appointmentId: appointment.id,
      recurrenceEndDate: appointment.recurrenceEndDate ? moment(appointment.recurrenceEndDate).tz(this.props.studentTimeZone) : null,
      studentNote: appointment.description,
      scheduleBlockInstructions: appointment.scheduleBlock.instructions,
      participants: appointment.scheduleBlock.groupSessionParticipants
    }))
    .catch(e => this.props.onFailure(apiErrorMessage(e)))
    .then(() => this.setState({hasFetched: true}));
  }

  render() {
    return (
      <ConfirmationView
        {...this.state}
        displayTeamMember={this.props.displayTeamMember}
        ownerPhotoURL={this.props.ownerPhotoURL}
      />
    );
  }
}

ConfirmationContainer.propTypes = {
  id: SFEntityID.isRequired,
  ownerPhotoURL: PropTypes.string,
  displayTeamMember: PropTypes.bool,
  studentTimeZone: PropTypes.string.isRequired,
  onFailure: PropTypes.func.isRequired
};
